import ConnectionForm from '~/components/ConnectionForm';

import Connected from '../Connected';

const Salesforce = ({ connector, connect }) => {
  return (
    <div>
      {connector ? (
        <Connected connector={connector}>
          <Connected.Detail
            description="Connected as"
            value={connector?.remoteMeta?.name}
            extra={connector?.remoteMeta?.email}
          />
          <Connected.Detail
            description="Account ID"
            value={connector?.remoteMeta?.organizationId}
            extra={
              connector.service === 'salesforcesandbox'
                ? 'Sandbox'
                : 'Production'
            }
          />
        </Connected>
      ) : (
        <ConnectionForm service="salesforce" auth={connect} />
      )}
    </div>
  );
};

Salesforce.propTypes = {
  connector: PropTypes.shape({
    remoteMeta: PropTypes.shape({
      name: PropTypes.string,
      email: PropTypes.string,
      organizationId: PropTypes.string,
    }),
  }),
  connect: PropTypes.func,
};

export default Salesforce;
